import {Field, FieldProps} from 'formik';
import { toEnglishDigits } from '../../../utilities/helper/toEnglishNumber';

import InputGroupOutlet from '../../inputGroupOutlet';

interface TFormikSelectProps extends React.HTMLProps<HTMLInputElement> {
  name: string;
  label: string;
  secondaryTitle?: string;
  Options: Array<IOption>;
  optionName: string;
  disabled?: boolean;
}
const FormikInputGroup = ({
  name,
  label,
  Options,
  optionName,
  disabled,
  secondaryTitle,
  ...props
}: TFormikSelectProps) => {
  return (
    <>
      <Field as="select" name="color">
        {({form}: FieldProps) => (
          <>
            <InputGroupOutlet
              name={name}
              required={props.required}
              disabled={disabled}
              label={label}
              secondaryTitle={secondaryTitle}
              value={form?.values[name]}
              onBlur={() => form?.setFieldTouched(name, true)}
              errors={form?.errors[name]?.toString()}
              touched={Boolean(form?.touched[name])}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const value = toEnglishDigits(e.target.value);
                form?.setFieldValue(name, value);
              }}
              Options={Options}
              setOptionValue={(value: string) => {
                form?.setFieldValue(optionName, value);
              }}
              optionValue={form?.values[optionName]}
              {...props}
            />
          </>
        )}
      </Field>
    </>
  );
};

export default FormikInputGroup;
